import "./ConnectingToStreamLoader.scss"

import { TableEmptyMessage } from "@skylead/component-library"
import React from "react"

import { useGlobalTranslation } from "../../../utils/hook"
import LoadingBar from "../LoadingBar"

const ConnectingToStreamLoader = () => {
  const { tt } = useGlobalTranslation()
  return (
    <div className="stream-loader-wrapper">
      <TableEmptyMessage
        icon="illustration-style-02"
        svgClassName="illustration-svg"
        exactHeight="unset"
        illustrationMessage={tt("connecting.to.stream.loader.empty-message.msg")}
        tt={tt}
      />

      <div className="stream-loader">
        <LoadingBar />
      </div>
    </div>
  )
}

// ConnectingToStreamLoader.propTypes = {}

export default ConnectingToStreamLoader
